import { useRouter } from '@tanstack/react-router';

import { useAuth } from '@/providers/AuthProvider/AuthProvider';

import { AppHeaderView } from './AppHeader.view';

export interface AppHeaderOrchestratorProps {
  opened: boolean;
  onToggle: () => void;
}

export const AppHeaderOrchestrator = ({ opened, onToggle }: AppHeaderOrchestratorProps) => {
  const router = useRouter();
  const { userData } = useAuth();

  const handleBack = () => {
    router.history.back();
  };

  return (
    <AppHeaderView opened={opened} onToggle={onToggle} onBack={handleBack} userData={userData} />
  );
};
